import React from "react";
import studioBanner from "../../assets/soulflow-banner.png";

export default function HeroRecords() {
  return (
    <div className="w-full flex flex-col items-center select-none">
      {/* Hero Banner Container */}
      <div
        className="w-full h-[350px] md:h-[580px] bg-cover bg-center relative flex items-center justify-center"
        style={{ backgroundImage: `url(${studioBanner})` }}
      >
        {/* Dark vignette overlay */}
        {/* <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-black/80"></div> */}

        {/* Glowing Title Overlay */}
        {/* <div className="relative z-10 text-center px-4 max-w-4xl animate-fade-down">
          <div className="border-y border-secondary/40 py-6 px-8 bg-black/40 backdrop-blur-sm rounded-lg inline-block">
            <h1 className="text-4xl sm:text-5xl md:text-7xl font-bold font-anton tracking-wider text-white uppercase drop-shadow-[0_5px_15px_rgba(255,140,33,0.35)]">
              B.A.B SOULFLOW
            </h1>
            <div className="text-secondary font-oswald text-xl sm:text-2xl md:text-3xl tracking-[0.25em] font-medium uppercase mt-2">
              RECORDS
            </div>
          </div>
        </div> */}
      </div>

      {/* Description Section */}
      <div className="w-full max-w-4xl text-center px-6 pt-12 pb-6 flex flex-col items-center">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold font-oswald text-secondary tracking-wide uppercase mb-3 drop-shadow-[0_2px_10px_rgba(255,140,33,0.2)]">
          B.A.B SOULFLOW RECORDS
        </h2>
        <h3 className="text-lg sm:text-xl font-semibold font-oswald text-white tracking-[0.2em] uppercase mb-8 opacity-80">
          A COMPLETE RECORD COMPANY
        </h3>

        <div className="space-y-6 max-w-3xl text-gray-300 font-outfit text-base sm:text-lg leading-relaxed">
          <p>
            AJB's SoulFlow Records is the official music powerhouse of BAB Media. The label delivers original
            albums, singles, soundtracks, and exclusive artist releases - all available for streaming, download,
            and purchase directly on the platform.
          </p>
          <p className="text-gray-400 text-sm sm:text-base italic">
            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the
            industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type
            and scrambled it to make a type specimen book.
          </p>
        </div>
      </div>
    </div>
  );
}
